<template>
	<span v-if="params.value" class="delivery-location-renderer">
		<span v-if="badge" class="delivery-location-renderer__badge">{{ badge }}</span>
		<span class="delivery-location-renderer__name">{{ params.value }}</span>
	</span>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
	params: { type: Object, required: true },
});

const badge = computed(() => props.params?.badge ?? null);
</script>

<style lang="scss">
.delivery-location-renderer {
	display: flex;
	align-items: center;
	gap: 8px;
	width: 100%;
	height: 100%;

	&__badge {
		flex: none;
		padding: 2px 8px;
		border: solid 1px rgb(var(--v-theme-primary), 0.8);
		color: rgb(var(--v-theme-primary), 0.8);
		border-radius: 20px;
		font-size: 12px;
		font-weight: 600;
		white-space: nowrap;
		height: 24px;
		line-height: 18px;
	}

	&__name {
		font-weight: 600;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
}
</style>
